import React, { useState, useEffect } from "react";
import { getUnterrichtPage } from "../lib/api";
import { Page, PageHeader, Section, SectionHead, IntroSplit, CardGrid, IconCard } from "../components/ui";
import IconByName from "../components/IconByName";
import "../styles/LernenUndVerstehen.css";

export default function LernenUndVerstehen() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [activeKey, setActiveKey] = useState(null);

  useEffect(() => {
    let cancelled = false;
    getUnterrichtPage()
      .then((res) => {
        if (!cancelled) {
          setData(res);
          setActiveKey(res.tabs?.[0]?.key ?? null);
        }
      })
      .catch((err) => !cancelled && setError(err));
    return () => {
      cancelled = true;
    };
  }, []);

  const {
    heroTitle,
    heroSubtitle,
    heroImage,
    introKicker,
    introTitle,
    introText,
    tabs,
    weekGrid,
    tabsSectionTitle,
    tabsSectionSubtitle,
    weekSectionTitle,
    weekSectionSubtitle,
  } = data || {};

  const activeTab = tabs?.find((t) => t.key === activeKey) || tabs?.[0];

  return (
    <Page loading={!data} error={error}>
      <PageHeader
        parent={{ label: "Lernwelt", to: "/lernen-und-verstehen" }}
        current="Lernen & Verstehen"
        title={heroTitle}
        subtitle={heroSubtitle}
      />

      <Section intro>
        <IntroSplit image={heroImage} kicker={introKicker} title={introTitle} text={introText} />
      </Section>

      {/* Tabs stay page-specific — this click-to-switch panel with an
          image doesn't recur elsewhere on the site. */}
      <Section>
        <SectionHead title={tabsSectionTitle} subtitle={tabsSectionSubtitle} />

        <div className="unt-tabs" role="tablist" aria-label="Unterricht Schwerpunkte">
          {(tabs || []).map((tab) => {
            const isActive = tab.key === activeKey;
            return (
              <button
                key={tab.key}
                type="button"
                className={`unt-tab ${isActive ? "is-active" : ""}`}
                onClick={() => setActiveKey(tab.key)}
                role="tab"
                aria-selected={isActive ? "true" : "false"}
              >
                <span className="unt-tab__ic" aria-hidden="true">
                  <IconByName name={tab.iconName} />
                </span>
                <span>{tab.label}</span>
              </button>
            );
          })}
        </div>

        {activeTab ? (
          <div className="unt-panel" role="tabpanel">
            <div className="unt-panel__text">
              <div className="unt-panel__kicker">
                <span aria-hidden="true">
                  <IconByName name={activeTab.iconName} />
                </span>
                <p>{activeTab.kicker}</p>
              </div>
              <h3>{activeTab.title}</h3>
              <p>{activeTab.text}</p>
              <ul className="unt-bullets">
                {(activeTab.bullets || []).map((bullet, i) => (
                  <li key={i}>{bullet}</li>
                ))}
              </ul>
            </div>
            {activeTab.image ? (
              <figure className="unt-panel__image">
                <img src={activeTab.image.url} alt={activeTab.image.alt || activeTab.title} loading="lazy" />
              </figure>
            ) : null}
          </div>
        ) : null}
      </Section>

      <Section>
        <SectionHead title={weekSectionTitle} subtitle={weekSectionSubtitle} />

        <CardGrid cols={3}>
          {(weekGrid || []).map((item, i) => (
            <IconCard
              key={item.id ?? i}
              iconName={item.iconName}
              title={item.title}
              text={item.note}
              layout="row"
            />
          ))}
        </CardGrid>
      </Section>
    </Page>
  );
}